import React, { useEffect, useContext } from 'react';
import CodeSystemBody from './CodeSystemBody';
import CodeSystemSidebar from './CodeSystemSidebar';
import './PageCodeSystem.css';
import QueryCSContextProvider from '../contexts/QueryCSContext';
import { GlobalContext } from '../contexts/GlobalContext';

function PageCodeSystem() {

	const globals = useContext(GlobalContext)

	useEffect(() => {
		globals.initAnalytics();
		globals.logPageAnalytics();
	}, [globals])

	return (
		<div className="pageCodeSystem">
			<QueryCSContextProvider>
				<CodeSystemSidebar />
				<CodeSystemBody />
			</QueryCSContextProvider>
		</div>
	);
}

export default PageCodeSystem;
